import { Component, OnInit } from "@angular/core"
import { FormControl, Validators, FormBuilder, FormGroup } from "@angular/forms"
import { Router } from "@angular/router"
import { MessageService } from "../../services/login.service"
import { KapraoService } from "../../services/kaprao.service"
import * as packageInfo from "../../../package.json"

@Component({
    selector: "app-login",
    templateUrl: "./login.component.html",
    styleUrls: ["./login.component.scss"],
})
export class LoginComponent implements OnInit {
    loginFormf: FormGroup
    showPassC1 = false
    error
    p = {}
    sm = {}
    version
    constructor(
        private formBuilder: FormBuilder,
        private service: KapraoService,
        private router: Router,
        private messageService: MessageService
    ) {
        this.loginFormf = this.formBuilder.group({
            username: new FormControl("", [Validators.required]),
            password: new FormControl("", [Validators.required]),
        })
    }

    ngOnInit(): void {
        let a = packageInfo
        let v = a.version.split("-")
        this.version = v[0]
        console.log(this.version)
        if (localStorage.getItem("token")) {
            this.router.navigate(["./dashboard/dashboard"])
        }
    }
    onLogin() {
        if (this.loginFormf.valid) {
            let dataLogin = {
                username: this.loginFormf.value.username,
                password: this.loginFormf.value.password,
            }
            this.service.login(dataLogin).then((res: any) => {
                if (res.code == "0000") {
                    localStorage.setItem("token", res.data.token)
                    res.data.menu.forEach((element) => {
                        Object.assign(this.p, {
                            [element.code]: element.role,
                        })
                        element.subMenu.forEach((sm) => {
                            console.log(sm)
                            Object.assign(this.sm, {
                                [sm.code]: true,
                            })
                        })
                    })
                    localStorage.setItem("p", JSON.stringify(this.p))
                    localStorage.setItem("sm", JSON.stringify(this.sm))
                    localStorage.setItem("m", JSON.stringify(res.data.menu))

                    this.messageService.sendMessage("login")
                    this.router.navigate(["./dashboard/dashboard"])
                } else {
                    // console.log(res)
                    this.error = res.message
                }
            })
        }
    }
}
